module.exports = __webpack_public_path__ + "static/media/xiaoicon_shuoming.06e8159a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xiaoicon_shuoming.png
// module id = 777
// module chunks = 0 1